import { css } from "styled-components"

export default props => {
  const { thickness, leftOffset, color } = {
    thickness: 2,
    leftOffset: "0px",
    color: "accent",
    ...props,
  }
  return css`
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 100%;
      right: 0;
      display: block;
      width: 0;
      height: ${thickness}px;
      background: ${({ theme }) => theme.colors[color]};
      transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &:hover {
      &::before {
        width: calc(100% - ${leftOffset});
        right: auto;
        left: ${leftOffset};
        transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }
    }
  `
}
